<template lang="pug">
  div.m-0.p-0
    div.d-flex
      button.btn.btn-success.btn-sm.ml-2(type='button' @click='onClick') {{ buttonText }}
</template>

<script>
//libs

export default {
  props: {
    state_name: {
      type: String,
      default: "heatmap"
    },
  },
  methods: {
    async onClick(){
      this.data_is_simul_display = !this.data_is_simul_display
      this.$store.commit(`${this.state_name}/setSimulDisplay`, this.data_is_simul_display)
    },
  },
  data(){
    return {
      data_is_simul_display: false,
    }
  },
  created() {
    this.data_is_simul_display = this.$store.state[this.state_name].simul_display
  },
  computed: {
    buttonText() {
      return this.data_is_simul_display ? '同時表示をやめる' : '同時表示';
    },
  },
}
</script>

